// src/App.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Home from './components/Pages/home';
import Error from './components/Pages/ErrorPage';
import InfoPage from './components/Pages/infoPage';
import Search from './components/Pages/Search';
import ProductDetail from './UI/productDetail';
import ShoppingCart from './components/Pages/shoppingCart';
import OrderDetail from './components/Pages/OrderDetail';
import Confirmation from './components/Pages/ConfirmationPage';
import ChangePass from './components/SignIn/ChangePass';
import Login from './components/SignIn/Login';
import AdminHome from './components/Admin/AdminPages/AdminHome';
import Layout from './components/Layout/Layout';
import AdminLayout from './components/Admin/AdminLayout/layout';
import OrderHistory from './components/Pages/OrderHistory';
import Expired from './components/Pages/Expired';
import ProductUpload from './components/Admin/AdminPages/ProductUpload';
import SingUp from './components/Pages/SingUp';
import { ProtectedAdminRoute, ProtectedUserRoute } from './components/Auth/ProtectedRoute';
import OrderDashboard from './components/Admin/AdminPages/OrderDashboard';
import ManageArticle from './components/Admin/AdminPages/ManageArticle';
import { useSelector } from 'react-redux';
import UserRequest from './components/Admin/AdminPages/UserRequest';
// import { ManualOrder } from './components/Pages/ManualOrder';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './components/ToastStyles/ToastStyles.css';

import ManageCatalog from './components/Admin/AdminPages/ManageCatalog';

const App = () => {
	const { auth } = useSelector((state) => state.auth);

	return (
		<div>
			<div>
				<Routes>
					{/* User routes */}
					<Route
						element={
							<ProtectedUserRoute>
								<Layout />
							</ProtectedUserRoute>
						}>
						<Route path='/dashboard' element={<Home />} />
						<Route path='/confirmation' element={<Confirmation />} />
						<Route path='/orderdetail' element={<OrderDetail />} />
						<Route path='/order-history' element={<OrderHistory />} />
						<Route path='/info' element={<InfoPage />} />
						<Route path='/search' element={<Search />} />
						<Route path='/productdetail/:id' element={<ProductDetail />} />
						<Route path='/changepassword' element={<ChangePass />} />
						<Route path='/shoppingcart' element={<ShoppingCart />} />
						{/* <Route path='/manualorder' element={<ManualOrder />} /> */}
					</Route>

					<Route path='/session_expired' element={<Expired />} />

					{/* Admin routes */}
					<Route
						element={
							<ProtectedAdminRoute>
								<AdminLayout />
							</ProtectedAdminRoute>
						}>
						<Route path='/adminhome' element={<AdminHome />} />
						<Route path='/upload' element={<ProductUpload />} />
						<Route path='/orderdashboard' element={<OrderDashboard />} />
						
						<Route path='/managearticle' element={<ManageArticle/>} />
						<Route path='/manageCatalog' element={<ManageCatalog/>}/>
						<Route path='/userrequest' element={<UserRequest />} />
					</Route>

					{/* Error, login, and session expiration routes */}
					<Route
						path='/'
						element={
							auth ? (
								auth.role === 'ADMIN' ? (
									<Navigate to='/adminhome' replace />
								) : (
									<Navigate to='/dashboard' replace />
								)
							) : (
								<Login />
							)
						}
					/>
					<Route
						path='/signup'
						element={
							auth ? (
								auth.role === 'ADMIN' ? (
									<Navigate to='/adminhome' replace />
								) : (
									<Navigate to='/dashboard' replace />
								)
							) : (
								<SingUp />
							)
						}
					/>

					<Route path='*' element={<Error />} />
				</Routes>
			</div>
			<ToastContainer
				position='top-right'
				autoClose={1000}
				hideProgressBar={true}
				closeOnClick
				pauseOnHover
				draggable
				pauseOnFocusLoss
				className=' mt-10'
			/>
		</div>
	);
};

export default App;
